<template>
  <div class="d-flex align-center pb-3">
    <v-btn text icon color="black" @click="goBack()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <div class="text-h4 font-weight-medium ml-1">
      {{ title }}
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue2-helpers/vue-router';

export default {
  components: {},
  props: {
    title: {
      type: String,
      required: true
    },
    goBack: {
      type: Function,
      required: true
    }
  },
  setup () {
    return { };
  }
};
</script>
